import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { NgbModule } from "@ng-bootstrap/ng-bootstrap"
import { InViewportModule } from "ng-in-viewport"

import { BrowseByGradeComponent } from "./browse-by-grade.component"
import { SharedComponentsModule } from "../shared-components/shared-components.module"
import { BrowseByGradeRoutingModule } from "./browse-by-grade-routing.module"
import { BrowseByGradeResultsGroupComponent } from "./browse-by-grade-results-group/browse-by-grade-results-group.component"
import { GradeAccessGuards } from "../guards/GradeAccess.guards"

@NgModule({
    declarations: [BrowseByGradeComponent, BrowseByGradeResultsGroupComponent],
    imports: [
        CommonModule,
        SharedComponentsModule,
        BrowseByGradeRoutingModule,
        NgbModule,
        InViewportModule,
    ],
    providers: [GradeAccessGuards],
})
export class BrowseByGradeModule {}
